import React, { useEffect } from "react";
import MainPage from "../MainPage";
import SessionStorage from "../../Constants/SessionStorage";
import { getRedirectQueryParams, listener } from "../../Constants/Utilities";
import { AppStorageKeys, DeviceManagePaths } from "../../Constants/Constants";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

export const DeviceProvisioning = (props) => {
  console.log("DeviceProvisioning props", props);
  const history = useHistory();
  const dispatch = useDispatch();
  const { protocol, hostname } = window.location;
  const deviceManageUrl =
    protocol + "//" + hostname + ":" + ENV_VARS.DEVICE_MANAGE_PORT;
  const redirectUrl = getRedirectQueryParams(DeviceManagePaths.device);

  useEffect(() => {
    listener(history, dispatch);
  }, []);
  return (
    <MainPage iframe={true}>
      <iframe
        title="DeviceProvisioning"
        className="new-frame"
        src={deviceManageUrl + "/login?" + redirectUrl}
      />
    </MainPage>
  );
};

export default DeviceProvisioning;
